import { Content } from "../../api-models/content";
import { ContentFiles } from "../../api-models/content";

export class PlaylistExampleFiles extends ContentFiles {
    Content: Content;
}